//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The entity that attribute applies to */
export const RegistrationFieldSource = {
    /** Person field */
    PersonField: 0,

    /** Person attribute */
    PersonAttribute: 1,

    /** Group Member attribute */
    GroupMemberAttribute: 2,

    /** Registrant attribute */
    RegistrantAttribute: 4
} as const;

/** The entity that attribute applies to */
export const RegistrationFieldSourceDescription: Record<number, string> = {
    0: "Person Field",

    1: "Person Attribute",

    2: "Group Member Attribute",

    4: "Registrant Attribute"
};

/** The entity that attribute applies to */
export type RegistrationFieldSource = typeof RegistrationFieldSource[keyof typeof RegistrationFieldSource];
